import { render, staticRenderFns } from "./IconDashboard.vue?vue&type=template&id=b309325e"
import script from "./IconDashboard.vue?vue&type=script&lang=js"
export * from "./IconDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports